import * as React from "react";
const SvgCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 9, height: 7, viewBox: "0 0 9 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.125 6.50875L0 3.38313L0.883125 2.5L3.125 4.74125L7.86562 0L8.75 0.884375L3.125 6.50875Z", fill: "#1DC116" }));
export default SvgCheck;
